export default {
  getSaleDetailList: {
    method: 'post',
    url: '/getSaleDetailList',
    desc: '获取销售明细'
  },
  getTodaySalesSummary: {
    method: 'post',
    url: '/getTodaySalesSummary',
    desc: '获取销售明细面板'
  },
  getSystemSkuWarnInfo: {
    method: 'post',
    url: '/getSystemSkuWarnInfo',
    desc: '获取系统Sku警告信息'
  },
  getSaleDetailTotal: {
    method: 'post',
    url: '/getSaleDetailTotal',
    desc: '获取销售明细总计'
  },
  createRefreshTask: {
    method: 'post',
    url: '/createRefreshTask',
    desc: '创建历史数据刷新任务'
  },
  getLastTaskStatus: {
    method: 'post',
    url: '/getLastTaskStatus',
    desc: '历史数据刷新任务状态'
  },
}
